// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module--title--1vAek","title__title":"Title-module--title__title--kv3Eb"};